import { render, staticRenderFns } from "./CatalogName.vue?vue&type=template&id=ac24a3cc&"
import script from "./CatalogName.vue?vue&type=script&lang=ts&"
export * from "./CatalogName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports